// eslint-disable-next-line import/no-anonymous-default-export
export default {
    defaultCurrency: 'USD',
    defaultLanguage: 'en',
    defaultLocale: 'en-us',
    namespace: 'shuttleGuide',
    supportedCurrencies: [
        'USD',
    ],
    supportedLocales: [
        'en-us',
    ],
};
